var PickupPoints = (function ($, _, CheckoutApiCollection, PickupPoint) {

	var PickupPoints = CheckoutApiCollection.extend({
		model: PickupPoint,

		initialize: function () {
			this._manageSelectedModel();
			this._updateSelectedModel();
		},

		getSelectedModel: function () {
			if (this._selectedModel && this._selectedModel.isSelected()) {
				return this._selectedModel;
			} else {
				return null;
			}
		},

		setSelectedModel: function (model, opts) {
			opts = _.extend({
				silent: true
			}, opts);

			this._selectedModel = model || this.where({ selected: true }).pop();

			if (!opts.silent) {
				this.trigger('setSelectedModel', this._selectedModel);
			}

			return this;
		},

		unselectModel: function () {
			var m = this.getSelectedModel();

			if (!m) {
				return;
			}

			var flag = this.isSelectedModelInCollection(m);

			m.unselect();

			if (!flag) {
				this.trigger('changeSelectedState', m);
			}
		},

		isSelectedModelInCollection: function (m) {
			var selected = m || this.getSelectedModel();
			return !!(selected && this.length && this.get(selected));
		},

		getSelectedModelPostcode: function () {
			var selectedModel = this.getSelectedModel();
			return selectedModel && selectedModel.get('Postcode') || '';
		},

		setSelectedModelByAttrs: function (attrs, opts) {
			if (!_.isEmpty(attrs)) {
				this.setSelectedModel(new this.model(_.extend(attrs, { selected: true })), opts);
			}
		},

		isValid: function () {
			var status = this.getSelectedModel() != null;
			this.trigger('validation', status);
			return status;
		},

		sync: function (method, collection, options) {
			if (method === 'read') {
				return this._syncRead(collection, options);
			}

			throw new Error('PickupPoints collection does not support "' + method + '" method.');
		},

		clear: function () {
			this.reset();
			this.setSelectedModel();
			this.trigger('clear');
		},

		_syncRead: function (collection, options) {
		    return this._api.getPickupPointsByPostcode({ postcode: options.postcode }, { hideErrors: true }).done(function (data) {
				options.success && options.success(data.Value, null, this);
				collection.trigger('sync', collection, data.Value, options);
			}).fail(function () {
				options.error && options.error(collection, this, options);
				collection.trigger('error', collection, this, options);
			});
		},

		_manageSelectedModel: function () {
			this.on('change:selected', function (model, value, opts) {
				if (opts && opts.__selectManagement) {
					return;
				}
				if (value) {
					this.each(function (m) { m !== model && m.unselect({ __selectManagement: true }); });
					this.setSelectedModel(model, { silent: true });
				}
				this.trigger('changeSelectedState', model, opts);
			});
		},

		_updateSelectedModel: function () {
			this.on('setSelectedModel sync', _.bind(function () {
				var selected = this.get(this.getSelectedModel());
				if (selected) {
					selected.select({ __selectManagement: true });
					this.setSelectedModel(selected, { silent: true });
				}
			}, this));
		}
	});

	return PickupPoints;
})($, _, CheckoutApiCollection, PickupPoint);
